import { AxiosError } from 'axios';

import { reservesConfig } from '../../config';
import { globalErrorResponse } from '../notifications/actions';
import {
    RESERVE_CLEAR_REQUIRED_SPOC,
    RESERVE_FETCH_REQUIRED_SPOC_SUCCESS,
    ReserveClearRequiredSpoc,
    ReserveFetchRequiredSpocSuccess,
    SET_RESERVE_LIST_ID,
    SetReserveListId
} from './types';
import RoutingUtils from '../../shared/utils/utils-routing';
import { RESERVE_ACCEPT_ACTION_VALUE, RESERVE_REJECT_ACTION_VALUE } from '../../shop/reserve/constants';
import * as consts from '../constants';
import { AppDispatch } from '../index';
import { SpocContextChangeResponse } from '../api';
import { http } from '../../api/axios';

const { endpointReserveRequiredSpoc } = reservesConfig();

export type ReserveActionValue = typeof RESERVE_ACCEPT_ACTION_VALUE | typeof RESERVE_REJECT_ACTION_VALUE;

export function openReserveListId(listId: string) {
    RoutingUtils.pushUrl(`${consts.PATH_RESERVE}/${listId}`);
}

export type FailReserveProductAcceptRejectType = {
    error: AxiosError;
    productId: string;
};

/* GENERATE */

export function fetchRequiredSpoc(reserveListId: string) {
    return (dispatch: AppDispatch) => {
        http.get(endpointReserveRequiredSpoc, {
            pathParams: { reserveListId }
        })
            .then(response => dispatch(fetchRequiredSpocSuccess(response.data)))
            .catch(error => dispatch(globalErrorResponse(error)));
    };
}

export const clearRequiredSpoc = (): ReserveClearRequiredSpoc => {
    return { type: RESERVE_CLEAR_REQUIRED_SPOC };
};
export const fetchRequiredSpocSuccess = (spoc: SpocContextChangeResponse): ReserveFetchRequiredSpocSuccess => {
    return { type: RESERVE_FETCH_REQUIRED_SPOC_SUCCESS, payload: spoc };
};

export const setActiveReserveListId = (listId: string): SetReserveListId => {
    return { type: SET_RESERVE_LIST_ID, payload: listId };
};
